/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * An event invitation the organization has not accepted; `deadline` is the event's end.
 * @export
 * @interface PendingInvitation
 */
export interface PendingInvitation {
    /**
     * 
     * @type {string}
     * @memberof PendingInvitation
     */
    event_id: string;
    /**
     * 
     * @type {string}
     * @memberof PendingInvitation
     */
    event_name: string;
    /**
     * 
     * @type {Date}
     * @memberof PendingInvitation
     */
    deadline: Date;
}

/**
 * Check if a given object implements the PendingInvitation interface.
 */
export function instanceOfPendingInvitation(value: object): value is PendingInvitation {
    if (!('event_id' in value) || value['event_id'] === undefined) return false;
    if (!('event_name' in value) || value['event_name'] === undefined) return false;
    if (!('deadline' in value) || value['deadline'] === undefined) return false;
    return true;
}

export function PendingInvitationFromJSON(json: any): PendingInvitation {
    return PendingInvitationFromJSONTyped(json, false);
}

export function PendingInvitationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PendingInvitation {
    if (json == null) {
        return json;
    }
    return {
        
        'event_id': json['event_id'],
        'event_name': json['event_name'],
        'deadline': (new Date(json['deadline'])),
    };
}

export function PendingInvitationToJSON(json: any): PendingInvitation {
    return PendingInvitationToJSONTyped(json, false);
}

export function PendingInvitationToJSONTyped(value?: PendingInvitation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'event_id': value['event_id'],
        'event_name': value['event_name'],
        'deadline': ((value['deadline']).toISOString()),
    };
}

